import {colors} from 'shells/colors/colors';
import {Leaderboard} from 'shells/leaderboard/leaderboard';
import type {OtherLeaderboardRows} from 'shells/leaderboard/types';

import type {GetChatbotReport_chatbotReport_dbMetrics_topNudges as TopNudge} from 'nutshell-graphql-types';

import {hexToRgba} from '../../forms/helpers';

import {NUDGES_EMPTY_STATE_PROPS} from './consts';
import {THREAD_SIDEBAR_OPEN_SOURCES} from './consts';
import {formatPageSlugs} from './helpers';
import {useOpenThreadListSidebar} from './use-open-thread-list-sidebar';

import styles from './top-nudges-section.module.css';

interface Props {
    topNudges: TopNudge[];
    secondaryColor: string;
}

export function TopNudgesSection(props: Props) {
    const openThreadListSidebar = useOpenThreadListSidebar();

    const borderAndTextColor =
        props.secondaryColor.toLowerCase() === colors.white?.toLowerCase()
            ? colors.black
            : props.secondaryColor;

    const bubbleOverlayColor = hexToRgba(props.secondaryColor, 0.1);

    const bubbleStyle = {
        border: `1px solid ${borderAndTextColor}`,
        color: borderAndTextColor,
        backgroundColor: colors.white,
        backgroundImage: `linear-gradient(${bubbleOverlayColor}, ${bubbleOverlayColor})`,
    };

    const rows: OtherLeaderboardRows = props.topNudges.map((nudge) => {
        const hasThreads = nudge.threadIds && nudge.threadIds.length > 0;
        const pageSlugTooltip = nudge.pageSlugs.length > 1 ? nudge.pageSlugs.join(', ') : undefined;

        return {
            id: nudge.nudgeId,
            rowType: 'other',
            label: nudge.content,
            value: `${nudge.threadCount} ${nudge.threadCount === 1 ? 'thread' : 'threads'}`,
            secondaryValue: formatPageSlugs(nudge.pageSlugs),
            secondaryValueTooltip: pageSlugTooltip,
            renderLabel: () => (
                <div className={styles['nudge-bubble']} style={bubbleStyle}>
                    {nudge.content}
                </div>
            ),
            onClick: hasThreads
                ? () =>
                      openThreadListSidebar({
                          threadIds: nudge.threadIds,
                          title: nudge.content,
                          subtitle: 'Conversations where this nudge was selected',
                          source: THREAD_SIDEBAR_OPEN_SOURCES.TOP_NUDGES_SECTION,
                      })
                : undefined,
        };
    });

    return (
        <div className={styles.wrapper}>
            <Leaderboard
                title='Top nudges'
                subtitle='Most selected nudge and their source page'
                rowsData={rows}
                hideMedal={true}
                emptyStateProps={NUDGES_EMPTY_STATE_PROPS}
                hasConsecutivePositions={true}
            />
        </div>
    );
}
